<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card sm:w-2/3 relative">
      <button class="system-button ml-auto" @click.prevent="close">
        <close-icon class="w-8 fill-current" />
      </button>

      <!-- <div class="mt-2 text-sm">
          <p class="font-medium">Comentarios</p>
          <p>{{ mealSet.comments }}</p>
        </div> -->

      <div class="mt-2 text-sm">
        <p class="font-medium">Comidas</p>

        <div
          v-for="(meal, i) in mealSet.meals"
          :key="meal.id"
          class="card w-full mt-2 border border-secondary-500"
        >
          <p>Comida #{{ i + 1 }}</p>

          <div class="flex flex-wrap">
            <div
              v-for="(portion, j) in meal.portions"
              :key="portion.id"
              class="card mt-2 mr-2 border border-tertiary-500"
            >
              <p>Porción #{{ j + 1 }}</p>
              <div class="mt-2 text-sm">
                <p class="font-medium">Categoría</p>
                <p>
                  {{ portion.diet_subcategory.diet_category.name }}
                </p>
              </div>

              <div class="mt-2 text-sm">
                <p class="font-medium">Subcategoría</p>
                <p>{{ portion.diet_subcategory.name }}</p>
              </div>

              <div class="mt-2 text-sm">
                <p class="font-medium">Cantidad</p>
                <p>{{ portion.quantity.toLocaleString() }}g</p>
              </div>
            </div>
          </div>

          <!-- <div class="mt-2 text-sm">
              <p class="font-medium">Comentarios</p>
              <p>{{ meal.comments }}</p>
            </div> -->

          <button
            v-if="addPrint"
            class="secondary-button mt-4 ml-0"
            @click.prevent="$emit('printMeal', meal.id)"
          >
            Imprimir Etiqueta Manualmente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Meal Set Modal",

  props: {
    mealSet: Object,
    addPrint: Boolean,
  },

  methods: {
    integerToCurrency,

    close() {
      this.$emit("close");
    },
  },
};
</script>